import { AllDcLocationsQuery, Exact } from "generated/graphql"
import { useAllDcLocations } from "graphql/distribution-center/distribution-center.hooks"
import React, { useEffect, useState } from "react"
import DCLocationPolygon from "./DCLocationPolygon"

interface AllDCLocationsProps {
  /**
   * Either pass distribution centres as props or don't
   * @default allDcLocations are fetched from the query if it is not passed from the props
   */
  distributionCentres?: AllDcLocationsQuery["allDistributionCentreLocations"]
  variables?: Exact<{
    pocId?: string
  }>
}
const AllDCLocations = ({
  distributionCentres,
  variables,
}: AllDCLocationsProps) => {
  const [dcs, setDcs] =
    useState<AllDcLocationsQuery["allDistributionCentreLocations"]>()
  const [getData, response] = useAllDcLocations({
    onCompleted(data) {
      setDcs(data.allDistributionCentreLocations)
    },
  })

  useEffect(() => {
    if (distributionCentres && distributionCentres?.length > 0) {
      setDcs(distributionCentres)
    } else {
      getData({ variables })
    }
  }, [distributionCentres, setDcs, getData, variables])

  useEffect(() => {
    const allDcs = response.data?.allDistributionCentreLocations
    if (!distributionCentres && allDcs && allDcs?.length > 0) {
      setDcs(allDcs)
    }
  }, [response, distributionCentres])

  return (
    <>
      {dcs?.map(dc => {
        return <DCLocationPolygon key={dc?.id} distributionCenter={dc} />
      })}
    </>
  )
}

export default AllDCLocations
